<template>
  <button
    class="btn"
    :class="buttonCss"
    :disabled="isLoading"
    @click="prepareToSend"
  >
    <i class="fa fa-fw" :class="iconCss" />
    {{ label }}
  </button>
</template>

<script>
import store from "@/stock/store";
export default {
  computed: {
    isLoading() {
      return store.state.inventory.isLoading;
    },
    items() {
      return store.state.inventory.items;
    },
    mode() {
      return store.state.inventory.mode;
    },
    buttonCss() {
      const theme = this.isFormatting ? 'success' : 'danger';
      return [`btn-${theme}`];
    },
    iconCss() {
      const name = this.isFormatting ? 'check' : 'arrow-left';
      return [`fa-${name}`];
    },
    label() {
      if (this.isFormatting) {
        return 'Принять список';
      }
      return 'Вернуться обратно';
    },
    isFormatting() {
      return !!(this.mode === 'formatting');
    },
  },
  methods: {
    prepareToSend() {
      if (this.mode === 'ready-to-send') {
        store.commit('inventory/setMode', 'formatting');
        return;
      }
      store.commit('inventory/setLoadStatus', true);
      const updatedItems = this.items.map((item) => {
        item.new_value = parseInt(item.new_value, 10);
        const { new_value, previous_value } = item;
        if (new_value === previous_value)
          item.operation_type = 'none';
        if (new_value > previous_value)
          item.operation_type = 'arrivals';
        if (new_value < previous_value)
          item.operation_type = 'write_offs';
        return item;
      });
      store.commit('inventory/setLoadStatus', false);
      store.commit('inventory/setMode', 'ready-to-send');
      store.commit('inventory/updateItems', updatedItems);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/features/inventory/PrepareButton.vue